/**
 * Ukrainian — the source locale. Every other locale is a partial override
 * of this object and falls back to it key by key.
 *
 * TODO(content): hero.stats and B2B terms come from the design brief;
 * confirm them with RDK production before launch.
 */
export const uk = {
  meta: {
    localeName: 'Українська',
    short: 'UA',
  },
  common: {
    next: 'Далі',
    back: 'Назад',
    soon: 'скоро',
    mm: 'мм',
    pcs: 'шт',
    ml: 'мл',
    copy: 'Копіювати',
    copied: 'Скопійовано',
    download: 'Завантажити',
    close: 'Закрити',
    requestQuote: 'Запит пропозиції',
    optional: 'необов’язково',
    demoCase: 'Демо-кейс',
  },
  nav: {
    printing: 'Можливості',
    products: 'Продукти',
    portfolio: 'Портфоліо',
    b2b: 'B2B',
    contact: 'Контакти',
    configurator: 'Створити свою свічку',
    menu: 'Меню',
    languageSoon: 'EN і PL — у розробці',
  },
  hero: {
    eyebrow: 'Цифровий циліндричний УФ-друк · Україна',
    titleA: 'Створюємо декор, який',
    titleAccent: 'продає',
    titleB: 'ваш продукт',
    lead: 'Друкуємо повноколірні зображення безпосередньо на склі, кераміці та упаковці — від 100 одиниць, без кліше та трафаретів. Для брендів свічок, косметики, напоїв та корпоративних подарунків.',
    cta: 'Створити свою свічку',
    secondary: 'Запит комерційної пропозиції',
    imageAlt: 'Свічки в бурштиновому та чорному склі з повноколірним квітковим друком',
    liveTitle: 'Прев’ю друку 360°',
    liveText: 'Завантажте логотип і подивіться, як він ляже на скло.',
    liveCta: 'Спробувати',
    stats: [
      { v: '360°', k: 'друк по колу без шва' },
      { v: '100+', k: 'мінімальний тираж' },
      { v: '1440', k: 'dpi роздільна здатність' },
      { v: '5–10', k: 'робочих днів виробництва' },
    ],
    materials: ['Скло', 'Кераміка', 'Метал', 'Пластик', 'Косметична тара', 'Пляшки', 'Свічки', 'Термоси'],
  },
  uv: {
    eyebrow: '01 — Технологія',
    title: 'Цифровий циліндричний УФ-друк',
    lead: 'Друкуюча голова наносить чорнило, поки виріб обертається, а УФ-лампа миттєво його полімеризує. Результат — стійке, насичене зображення прямо на поверхні, без наклейок і плівок. Формат: круглі вироби без ручки, Ø 45–160 мм, довжина 80–280 мм.',
    imageAlt: 'Циліндричний УФ-принтер друкує на скляній пляшці',
    points: [
      { t: '360° без переналаштування', d: 'Повне обгортання або точкове лого в одному проході.' },
      { t: 'Біла підкладка', d: 'Білий шар під кольором робить друк яскравим на прозорому, бурштиновому й чорному склі.' },
      { t: 'Лак і рельєф', d: 'Глянцевий або тактильний лак поверх кольору — декор, який відчувається на дотик.' },
      { t: 'Персоналізація', d: 'Кожен виріб може мати інший дизайн, ім’я або номер.' },
    ],
    layersTitle: 'Шари друку',
    layers: [
      { id: 'varnish', label: 'Varnish', d: 'захист, глянець, рельєф' },
      { id: 'cmyk', label: 'CMYK', d: 'повнокольорове зображення' },
      { id: 'white', label: 'White', d: 'біла підкладка' },
      { id: 'glass', label: 'Скло', d: 'основа' },
    ],
  },
  products: {
    eyebrow: '02 — Продукти',
    title: 'Що ми декоруємо',
    lead: 'Працюємо з вашою тарою або підбираємо її під проєкт.',
    configure: 'Налаштувати',
    request: 'Запитати',
    soonBadge: 'Конфігуратор онлайн',
    candle: {
      index: '2.1',
      title: 'Свічки',
      text: 'Скляні стакани для ароматичних свічок: прозорі, бурштинові, чорні, білі та матові. Логотип, часткове оформлення або повний обгорт.',
      chips: ['Скло', 'Друк по колу', 'Від 100 шт'],
      imageAlt: 'Свічка в матовому склі з повноколірним орнаментом',
      widgetTitle: 'Конфігуратор свічки',
      widgetLive: 'Live',
      widgetGlass: 'Скло',
      widgetContainer: 'Стакан',
      widgetCta: 'Налаштувати свою свічку',
    },
    items: {
      diffuser: {
        title: 'Дифузори',
        text: 'Флакони для аромадифузорів із мінімалістичною графікою, що підкреслює форму скла.',
        tags: ['#флакони', '#лінійна графіка'],
        imageAlt: 'Два флакони дифузорів з лінійним друком',
      },
      cosmetic: {
        title: 'Косметична упаковка',
        text: 'Баночки й флакони для кремів, сироваток і масел. Друк замість етикетки — чисто й преміально.',
        tags: ['#баночки', '#флакони', '#без етикетки'],
        imageAlt: 'Матові косметичні баночки та флакони з білим друком',
      },
      glass: {
        title: 'Скляні пляшки та банки',
        text: 'Пляшки для напоїв, крафтових продуктів та банки для делікатесів.',
        tags: ['#напої', '#horeca', '#food'],
        imageAlt: 'Скляні пляшки та банки з кольоровими орнаментами',
      },
      drinkware: {
        title: 'Термоси та спортивні пляшки',
        text: 'Термоси, пляшки для води й тумблери без ручки: друк по колу на сталі, порошковому покритті та склі.',
        tags: ['#термоси', '#спорт', '#мерч'],
        imageAlt: 'Термоси та спортивні пляшки з українською вишивкою на дерев’яному столі',
      },
      gift: {
        title: 'Корпоративні подарунки',
        text: 'Брендовані набори для команд і партнерів: свічки, термоси, пляшки — в одному стилі.',
        tags: ['#набори', '#команди'],
        imageAlt: 'Подарунковий набір у крафтовій коробці',
      },
    },
  },
  portfolio: {
    eyebrow: '03 — Портфоліо',
    title: 'Вибрані роботи',
    lead: 'Кілька прикладів того, як цифровий декор перетворює стандартну тару на впізнаваний продукт.',
    note: 'Ілюстративні візуалізації. Реальні кейси з фото додамо після погодження з клієнтами.',
    items: [
      { client: 'Бренд ароматичних свічок', title: 'Botanical Series', img: 'candle-frosted-tall' },
      { client: 'Косметична лабораторія', title: 'Amber Ritual', img: 'cosmetics' },
      { client: 'Концепт-стор', title: 'Noir Garden', img: 'hero-candles' },
      { client: 'Мережа кав’ярень', title: 'Folk Thermos', img: 'drinkware' },
      { client: 'Крафтова пивоварня', title: 'Craft Glass', img: 'bottles' },
      { client: 'IT-компанія', title: 'Welcome Box', img: 'gift-box' },
    ],
  },
  b2b: {
    eyebrow: '04 — Співпраця',
    title: 'B2B — для брендів, виробників і агенцій',
    lead: 'Ми не друкарня «на один раз». Будуємо довгострокове виробниче партнерство з прогнозованою якістю і термінами.',
    steps: [
      { t: 'Запит', d: 'Надішліть макет або налаштуйте виріб у конфігураторі.' },
      { t: 'Пропозиція', d: 'Протягом 1 робочого дня — розрахунок вартості та термінів.' },
      { t: 'Зразок', d: 'Друкуємо тестовий зразок для погодження кольору.' },
      { t: 'Тираж', d: 'Виробництво, контроль якості та доставка по Україні та ЄС.' },
    ],
    perks: ['Персональний менеджер проєкту', 'Складська програма та регулярні дозамовлення', 'Друк на тарі замовника', 'White-label для агенцій'],
    ctaTitle: 'Digital Decoration. Made Personal.',
    cta: 'Запит комерційної пропозиції',
  },
  contact: {
    eyebrow: '05 — Контакти',
    title: 'Запит комерційної пропозиції',
    lead: 'Опишіть задачу — підготуємо розрахунок і рекомендації щодо друку. Для свічок швидше скористатися конфігуратором.',
    interest: 'Напрям',
    interestOptions: ['Свічки', 'Дифузори', 'Косметична упаковка', 'Скляні пляшки та банки', 'Термоси та спортивні пляшки', 'Корпоративні подарунки', 'Інше'],
    message: 'Задача',
    messagePh: 'Виріб, тираж, терміни, посилання на макет…',
    send: 'Надіслати запит',
    sending: 'Надсилаємо…',
    sent: 'Запит {n} отримано. Ми відповімо на email протягом робочого дня.',
    or: 'Або зателефонуйте чи напишіть у месенджер',
  },
  form: {
    company: 'Компанія',
    contactPerson: 'Контактна особа',
    email: 'Email',
    phone: 'Телефон',
    quantity: 'Кількість, шт',
    comments: 'Коментар',
    commentsPh: 'Аромат, колір воску, кришка, пакування, терміни…',
    consent: 'Погоджуюсь на обробку контактних даних для підготовки пропозиції.',
  },
  validation: {
    required: 'Заповніть це поле',
    email: 'Перевірте адресу email',
    phone: 'Вкажіть телефон у форматі +380…',
    quantity: 'Вкажіть кількість від 1',
    consent: 'Потрібна ваша згода',
    configuration: 'Конфігурацію не завершено',
    spam: 'Запит відхилено',
  },
  errors: {
    network: 'Не вдалося з’єднатися із сервером. Перевірте інтернет і спробуйте ще раз.',
    server: 'Сервер не прийняв запит. Спробуйте ще раз або напишіть нам у Viber, Telegram чи WhatsApp: 093 946 75 25.',
    offline: 'Прев’ю-режим: сервер недоступний, тому запит не надіслано. Скопіюйте підсумок або завантажте JSON.',
  },
  footer: {
    rights: '© {y} RDK. Цифровий декор скла, кераміки та упаковки.',
    privacy: 'Політика конфіденційності',
  },
  cfg: {
    pageTitle: 'Конфігуратор',
    switcher: 'Оберіть продукт',
    families: {
      candle: {
        name: 'Свічки',
        title: 'Конфігуратор свічки',
        intro: 'Свічка у скляній тарі з вашим дизайном',
        containerTitle: 'Оберіть стакан',
        containerLead: 'Розмір зони друку залежить від форми. Точну тару підберемо під ваш віск і аромат.',
        materialStep: 'Скло',
        materialTitle: 'Оберіть скло',
        materialLead: 'Колір скла впливає на те, як виглядає друк. На темному та прозорому склі радимо білу підкладку.',
      },
      diffuser: {
        name: 'Дифузори',
        title: 'Конфігуратор дифузора',
        intro: 'Флакон аромадифузора з вашим дизайном',
        containerTitle: 'Оберіть флакон',
        containerLead: 'Друкуємо на циліндричній частині флакона, над рівнем рідини — щоб графіка читалась.',
        materialStep: 'Скло',
        materialTitle: 'Оберіть скло',
        materialLead: 'Прозоре скло показує аромат і палички; бурштинове та чорне — для преміальних ліній.',
      },
      bottle: {
        name: 'Пляшки та банки',
        title: 'Конфігуратор пляшки та банки',
        intro: 'Пляшка або банка з друком замість етикетки',
        containerTitle: 'Оберіть пляшку або банку',
        containerLead: 'Для напоїв, олії, соусів, меду та делікатесів. Друк — на прямій частині корпусу.',
        materialStep: 'Скло',
        materialTitle: 'Оберіть скло',
        materialLead: 'Для яскравого друку на кольоровому склі потрібна біла підкладка.',
      },
      cosmetic: {
        name: 'Косметична тара',
        title: 'Конфігуратор косметичної тари',
        intro: 'Баночка чи флакон для косметики з вашим дизайном',
        containerTitle: 'Оберіть тару',
        containerLead: 'Баночки для кремів, флакони з піпеткою, помпою та тонери. Дрібний текст і склад друкуємо до 6 pt.',
        materialStep: 'Скло',
        materialTitle: 'Оберіть скло',
        materialLead: 'Матове й біле скло — класика косметики; бурштинове та кобальтове захищають вміст від світла.',
      },
      drinkware: {
        name: 'Термоси й пляшки',
        title: 'Конфігуратор термоса та пляшки',
        intro: 'Термос, спортивна пляшка чи тумблер з повноколірним друком',
        containerTitle: 'Оберіть виріб',
        containerLead: 'Друк по колу майже на всю висоту корпусу. Кришку знімаємо на час друку.',
        materialStep: 'Покриття',
        materialTitle: 'Оберіть покриття',
        materialLead: 'Порошкове покриття — матове й тактильне; на білому кольори найточніші. Сталь і темні кольори друкуємо з білою підкладкою.',
      },
      gift: {
        name: 'Подарункові набори',
        title: 'Конфігуратор корпоративного набору',
        intro: 'Набір з вашим логотипом для команди чи партнерів',
      },
    },
    materials: {
      clear: { label: 'Прозоре', d: 'Видно вміст; для яскравого друку потрібна біла підкладка.' },
      amber: { label: 'Бурштинове', d: 'Теплий аптекарський стиль, захищає від світла, приглушує кольори.' },
      black: { label: 'Чорне', d: 'Преміальний вигляд; друк лише з білою підкладкою.' },
      white: { label: 'Біле (опал)', d: 'Найточніша передача кольору, як на папері.' },
      frosted: { label: 'Матове', d: 'М’яке розсіяне світло; друк — з білою підкладкою.' },
      green: { label: 'Зелене', d: 'Класика для олії, вина та крафтових напоїв.' },
      cobalt: { label: 'Кобальтове', d: 'Насичений синій, захищає вміст від світла.' },
      steel: { label: 'Сталь', d: 'Шліфована нержавіюча сталь; друк з білою підкладкою.' },
      powder_white: { label: 'Біле покриття', d: 'Матова біла порошкова фарба — найточніші кольори.' },
      powder_black: { label: 'Чорне покриття', d: 'Матове чорне, преміальний вигляд; друк з білою підкладкою.' },
      powder_sage: { label: 'Шавлієве покриття', d: 'Приглушений зелений, друк з білою підкладкою.' },
      powder_navy: { label: 'Темно-синє покриття', d: 'Глибокий синій; друк з білою підкладкою.' },
    },
    closures: {
      lid: 'кришка',
      cap: 'кришка',
      cork: 'корок',
      dropper: 'піпетка',
      pump: 'помпа',
      reeds: 'палички',
      thermo: 'кришка-чашка',
      sport: 'спорт-кришка',
      swing: 'бугельна пробка',
      tcork: 'корок з дерев’яною голівкою',
      wood: 'дерево',
      gold: 'золото',
      silver: 'срібло',
      black: 'чорна',
      white: 'біла',
      bamboo: 'ротанг',
    },
    steps: {
      container: 'Тара',
      glass: 'Матеріал',
      upload: 'Макет',
      editor: 'Розміщення',
      print: 'Друк',
      quantity: 'Тираж',
      rfq: 'Запит',
    },
    stepOf: 'Крок {n} з {total}',
    container: {
      printArea: 'Зона друку',
      limits: 'Друкуємо круглі вироби без ручки: Ø {d} мм, довжина {h} мм',
    },
    upload: {
      title: 'Завантажте макет',
      lead: 'PNG, JPG, SVG або PDF до 25 МБ. Файл обробляється одразу: перевіряємо тип, роздільність, прозорість і готуємо до розміщення.',
      drop: 'Перетягніть файл сюди',
      or: 'або',
      browse: 'Обрати файл',
      formats: 'PNG · JPG · SVG · PDF · до 25 МБ',
      processing: 'Обробляємо файл…',
      replace: 'Замінити файл',
      remove: 'Прибрати',
      designHelp: 'У мене немає макета — потрібна допомога з дизайном',
      designHelpNote: 'Добре. Ми запропонуємо дизайн після запиту. Розміщення можна пропустити.',
      uploaded: 'Збережено на сервері',
      uploading: 'Завантажуємо на сервер…',
      uploadLocal: 'Обробено локально',
      uploadFailed: 'Не вдалося зберегти на сервері — файл додамо при надсиланні запиту',
      info: {
        format: 'Формат',
        size: 'Розмір файлу',
        pixels: 'Пікселі',
        pages: 'Сторінок',
        vector: 'Вектор',
        transparency: 'Прозорість',
        yes: 'є',
        no: 'немає',
        checksum: 'SHA-256',
      },
      errors: {
        type: 'Цей тип файлу не підтримується. Завантажте PNG, JPG, SVG або PDF.',
        size: 'Файл більший за 25 МБ. Зменшіть його або надішліть посилання в коментарі.',
        decode: 'Файл пошкоджений або не відкривається. Спробуйте експортувати його ще раз.',
        pdf: 'Не вдалося відкрити PDF. Збережіть його як PDF/X або PNG і спробуйте знову.',
        svg: 'SVG не вдалося прочитати. Перевірте, що це коректний векторний файл.',
      },
    },
    warnings: {
      lowDpi: 'Низька роздільність: ~{dpi} dpi у розмірі друку. Для чіткого друку потрібно від 300 dpi.',
      midDpi: 'Роздільність ~{dpi} dpi — прийнятно, але дрібні деталі можуть бути нечіткими.',
      whiteBackground: 'Схоже, у макета білий фон. На кольоровому склі він надрукується білим прямокутником. Прибрати фон зможемо на препресі.',
      noTransparencyJpeg: 'JPG не має прозорості: фон буде надруковано.',
      svgText: 'У SVG є живий текст. Переведіть шрифти в криві, щоб текст не замінився іншим шрифтом.',
      svgSanitized: 'З SVG прибрано скрипти або зовнішні посилання ({n}).',
      svgRaster: 'SVG містить вбудовані растрові зображення — перевірте їх роздільність.',
      pdfPages: 'PDF має кілька сторінок ({n}). Для розміщення використано першу.',
      outsideBand: 'Частина макета виходить за межі зони друку й не буде надрукована.',
      blackNoWhite: 'На чорному матеріалі без білої підкладки кольори майже не видно.',
      clearNoWhite: 'Без білої підкладки кольори на цьому матеріалі будуть напівпрозорими.',
      noPrintZone: 'Макет заходить на зону біля ручки — там друк неможливий. Зсуньте його або зменшіть.',
    },
    editor: {
      title: 'Розмістіть макет',
      lead: 'Перетягуйте макет на свічці, тягніть кутові маркери для масштабу, верхній маркер — для повороту. Стрілки на клавіатурі зсувають на 1 мм.',
      viewFront: 'Вигляд на тарі',
      viewFlat: 'Розгортка',
      rotateView: 'Обертати тару',
      center: 'Центрувати',
      reset: 'Скинути',
      fitHeight: 'На всю висоту',
      fullWrap: 'Обгорнути 360°',
      width: 'Ширина',
      height: 'Висота',
      rotation: 'Поворот',
      posU: 'Позиція по колу',
      posV: 'Від верху зони',
      dpi: 'Роздільність у друці',
      vectorDpi: 'вектор — без втрати якості',
      coverage: 'Покриття зони',
      noArtwork: 'Макет не завантажено. Поверніться на крок «Макет» або залиште розміщення дизайнерам RDK.',
      seam: 'шов',
      noPrint: 'ручка — без друку',
      printBand: 'зона друку',
      unwrap: 'Розгортка {w} × {h} мм',
      stageLabel: 'Попередній перегляд свічки з макетом. Використовуйте стрілки, щоб зсунути макет.',
    },
    print: {
      title: 'Параметри друку',
      inkTitle: 'Фарби',
      inks: {
        cmyk: { label: 'CMYK', d: 'Повний колір без підкладки. Найкраще на білому склі.' },
        cmyk_white: { label: 'CMYK + White', d: 'Біла підкладка під кольором — яскраво на будь-якому склі.' },
        cmyk_white_varnish: { label: 'CMYK + White + Varnish', d: 'Додатковий шар лаку: глянець, захист і тактильний ефект.' },
      },
      coverageTitle: 'Декорування',
      coverages: {
        single_logo: { label: 'Одне лого', d: 'Компактний знак на лицьовій стороні.' },
        partial: { label: 'Часткове', d: 'Ілюстрація або композиція на частині кола.' },
        full_wrap: { label: 'Повне обгортання', d: 'Дизайн на всі 360° тари.' },
      },
      suggested: 'За вашим розміщенням: {v}',
      recommendedFor: 'Рекомендовано для цього скла',
      wrapHint: 'Макет займає {p}% кола. Для повного обгортання розтягніть його на всю окружність.',
      applyWrap: 'Розтягнути на 360°',
    },
    quantity: {
      title: 'Тираж',
      lead: 'Оберіть кількість свічок. Ціну розрахуємо у пропозиції — онлайн-оплати поки немає.',
      custom: 'Своя кількість',
      skus: 'Кількість дизайнів (SKU)',
      skusHint: 'Якщо в тиражі кілька різних дизайнів',
      date: 'Бажана дата відвантаження',
      smallRun: 'Тираж менше 100 шт розраховуємо індивідуально.',
    },
    rfq: {
      title: 'Запит комерційної пропозиції',
      lead: 'Перевірте конфігурацію та залиште контакти. Ми надішлемо розрахунок і, за потреби, зразок.',
      summary: 'Підсумок конфігурації',
      submit: 'Надіслати запит',
      submitting: 'Надсилаємо…',
      successTitle: 'Запит {n} отримано',
      successText: 'Ми перевіримо макет і надішлемо пропозицію на {email}. Номер запиту збережено в підсумку нижче.',
      draftTitle: 'Підсумок запиту (чернетка)',
      copySummary: 'Копіювати підсумок',
      downloadJson: 'Завантажити JSON',
      newConfig: 'Нова конфігурація',
      mockup: 'Мокап',
      edit: 'Змінити',
    },
    summary: {
      product: 'Продукт',
      productValue: 'Свічка у скляній тарі',
      container: 'Тара',
      glass: 'Скло',
      artwork: 'Макет',
      placement: 'Розміщення',
      ink: 'Фарби',
      coverage: 'Декорування',
      quantity: 'Тираж',
      skus: 'Дизайнів',
      date: 'Дата',
      noArtwork: 'Без макета — потрібен дизайн від RDK',
      notUploaded: 'Не завантажено',
    },
    nextRequires: {
      upload: 'Завантажте макет або позначте, що потрібна допомога з дизайном.',
    },
  },
  gift: {
    steps: {
      items: 'Склад',
      logo: 'Логотип',
      personal: 'Персоналізація',
      preview: 'Прев’ю',
      pack: 'Упаковка й тираж',
      rfq: 'Запит',
    },
    items: {
      title: 'Зберіть набір',
      lead: 'До 5 позицій — від свічки до термоса. Усі вироби отримають ваш логотип в одному стилі.',
      add: 'Додати',
      remove: 'Прибрати',
      inSet: 'У наборі',
      perSet: 'шт у наборі',
      form: 'Форма',
      material: 'Матеріал',
      empty: 'Додайте хоча б один виріб.',
      max: 'У наборі може бути до 5 позицій.',
      presets: 'Готові набори',
      presetList: [
        { id: 'welcome', name: 'Welcome Box', d: 'свічка + термос + пляшка' },
        { id: 'spa', name: 'Spa Set', d: 'свічка + дифузор + крем' },
        { id: 'coffee', name: 'Coffee Break', d: '2 тумблери + банка' },
      ],
    },
    logo: {
      title: 'Завантажте логотип',
      lead: 'Один логотип для всього набору. Найкраще — SVG або PDF у кривих, чи PNG з прозорим фоном.',
    },
    personal: {
      title: 'Персоналізація',
      lead: 'Додамо ім’я під логотип на кожному наборі — для команди чи партнерів.',
      none: 'Без персоналізації',
      noneD: 'Однаковий дизайн для всіх наборів.',
      names: 'Імена під логотипом',
      namesD: 'Кожен набір підписаний для конкретної людини.',
      listLabel: 'Список імен — по одному в рядку',
      listPh: 'Олена Коваль\nАндрій Мельник\nIryna Shevchenko',
      count: 'Імен: {n}',
      qtyHint: 'Кількість наборів оновлено за списком: {n}.',
      sample: 'Ім’я Прізвище',
    },
    preview: {
      title: 'Прев’ю набору',
      lead: 'Логотип автоматично розміщено на лицьовій стороні кожного виробу. Налаштуйте розмір і висоту.',
      scale: 'Розмір логотипа',
      offset: 'Вертикальне положення',
      rotate: 'Обертати вироби',
      previewName: 'Показати ім’я',
    },
    pack: {
      title: 'Упаковка й тираж',
      packTitle: 'Упаковка',
      options: {
        kraft: { label: 'Крафт', d: 'Крафтова коробка з паперовим наповнювачем.' },
        black_box: { label: 'Преміум', d: 'Чорна коробка з ложементом під кожен виріб і друком лого.' },
        none: { label: 'Без упаковки', d: 'Вироби окремо, для власного пакування.' },
      },
      qtyTitle: 'Кількість наборів',
      inkTitle: 'Фарби',
    },
    summaryItems: 'Склад набору',
    sets: 'наборів',
  },
  notFound: {
    title: 'Сторінку не знайдено',
    back: 'На головну',
  },
};

type Widen<T> = T extends string
  ? string
  : T extends readonly (infer U)[]
    ? Widen<U>[]
    : T extends object
      ? { [K in keyof T]: Widen<T[K]> }
      : T;

export type Dictionary = Widen<typeof uk>;
